<template>
  <div
    id="interactions-tab-container"
    element-loading-background="#F7F8FC"
    v-loading="loading"
  >
    <el-card
      :key="interaction.id"
      style="margin-bottom: 10px"
      v-for="interaction in interactions"
    >
      <message
        class="message"
        :audio="getOreValues(interaction, 'audio').value"
        :avatar="getOreValue(interaction, 'profile_image', null)"
        :class="{ 'first-message': interaction.id === firstInteractionId }"
        :comments="interaction.comments"
        :channel="interaction.type"
        :displayName="getOreValue(interaction, 'display_name')[0] || ''"
        :datetime="moment(interaction.date_created)"
        :datetimeIsChanged="datetimeIsChanged"
        :images="getOreValues(interaction, 'image').value"
        :id="interaction.id"
        :isOnAir="type === 'onair'"
        :key="interaction.id"
        :message="getOreValue(interaction, 'message')"
        :originator="getOreValue(interaction, 'originators')"
        :originatorType="getOreValues(interaction, 'originators').type[0]"
        :onAirUsers="onAirUsers"
        :parentInteraction="interaction.parent"
        :replies="interaction.replies"
        :video="getOreValues(interaction, 'video').value"
        :showTools="false"
        :autoCollapseParentInteraction="true"
        @changeDatetimePostFormat="changeDateFormat"
      />
    </el-card>
  </div>
</template>

<script>
import moment from 'moment';
import Message from '@/components/interaction/Message';

export default {
  name: 'ProfileInteractionsTab',
  components: {
    Message,
  },
  data: () => ({
    datetimeIsChanged: null,
  }),
  props: {
    interactions: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    onAirUsers: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
    },
  },
  methods: {
    changeDateFormat(date) {
      this.datetimeIsChanged = date;
      const parsed = JSON.stringify(this.datetimeIsChanged);
      localStorage.setItem('changeDatetimePostFormat', parsed);
    },
    firstInteractionId() {
      return this.interactions[0].id;
    },
    getOreValue(interaction, key, defaultVal = '') {
      if (Object.prototype.hasOwnProperty.call(interaction.ore, key)) {
        return (interaction.ore[key].value[0]) || defaultVal;
      }
      return defaultVal;
    },
    getOreValues(interaction, key) {
      if (Object.prototype.hasOwnProperty.call(interaction.ore, key)) {
        return interaction.ore[key] || [];
      }
      return [];
    },
    moment(datetime) {
      return moment(datetime);
    },
  },
};
</script>

<style scoped>
#interactions-tab-container {
  overflow-y: scroll;
  height: 430px;
  padding: 0 8px
}
</style>



// WEBPACK FOOTER //
// InteractionsTab.vue?093caeba